export const EXHAUSTED_HINT_ALLOWANCE_MESSAGE = 'Hai usato i due aiutini gratuiti per questo gioco. Crea un account gratuito per ottenere gettoncini e continuare a usare gli aiutini.';
export const HINT_AUTH_MESSAGE = 'Per usare gli aiutini hai bisogno di gettoncini, che puoi guadagnare con un account gratuito.';

export const hasFreeAnonymousHints = (allowance, gameSlug, isSignedIn) => (
  !isSignedIn && allowance?.game_slug === gameSlug
  && allowance?.eligible === true && allowance.remaining > 0
);

export const getHintAuthMessage = (allowance) => (
  allowance?.eligible && allowance.used >= 2
    ? EXHAUSTED_HINT_ALLOWANCE_MESSAGE : HINT_AUTH_MESSAGE
);
